import { render, staticRenderFns } from "./VirtualBackground.vue?vue&type=template&id=433611cb&scoped=true"
import script from "./VirtualBackground.vue?vue&type=script&setup=true&lang=ts"
export * from "./VirtualBackground.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VirtualBackground.vue?vue&type=style&index=0&id=433611cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433611cb",
  null
  
)

export default component.exports